export default {
	title: 'Recall RFID装箱验货程序',
	zh: '中文简体',
	en: 'English',
	早上好: '早上好',
	中午好: '中午好',
	下午好: '下午好',
	晚上好: '晚上好',
	服装: '服装',
	鞋类: '鞋类',
	管理员: '管理员',
	只读管理员:'只读管理员',
	普通用户: '普通用户',
	禁用: '禁用',
	正常: '正常',
	用户登录: '用户登录',
	扫描单保存: 'PDA保存上传',
	EPC明细导出: '装箱明细导出',
	修改设备: '修改设备',
	删除设备: '删除设备',
	添加设备: '添加设备',
	未上传:'未上传',
	上传成功:'上传成功',
	上传失败:'上传失败',
	开始日期:'开始日期',
	结束日期:'结束日期',
	404: 'not-found',
	back: '返回',
	goHome: '回首页',
	placeholder: '请输入',
	login: {
		title: '欢迎登录！',
		submit: '登 录',
	},
	updatePassword: '修改密码',
	logout: '退出登录',
	name: '用户名',
	username: '账号',
	password: '密码',
	oldPwd: '原密码',
	Pwd: '新密码',
	twoPwd: '再次输入密码',
	okPwd: '确认密码与新密码不一致!',
	pwdTip: '密码修改成功！',
	submit: '提交',
	search: '查询',
	create: '新增',
	edit: '修改',
	confirm: '确定',
	cancel: '取消',
	export: '导出',
	export1: '导出汇总',
	export2: '导出明细',
	serial: '序号',
	operate: '操作',
	del: '删除',
	tip: '提示',
	tipOk: "确定删除",
	success: '操作成功',
	unsuccess: '操作失败',
	article: '本条',
	history: '装箱查询',
	single:'单标签',
	double: '双标签',
	
	factoryNumber: '工厂编号',
	factory_number: '工厂编号',
	factory_name: '工厂名称',
	factoryName: '工厂名称',
	work_order_number: '订单号',
	order_number: '箱号',
	
	all_number: '数量',
	count_number: '数量',
	
	tipo_depr: '产品类型',
	goods_type: '产品类型',
	
	modelo: '产品型号',
	goods_style: '产品型号',
	
	calidad: '产品质量',
	goods_quality: '产品质量',
	
	color: '产品颜色',
	goods_colour: '产品颜色',
	
	talla: '产品尺寸',
	goods_size: '产品尺寸',
	
	create_time: '装箱日期',

	equ: '设备列表',
	device_name: '设备名称',
	device_model: '工作模式',
	device_type: '设备类别',
	device_id:'设备ID',
	device_version: '系统版号',
	longitude: '经度',
	latitude: '纬度',
	user: '用户管理',
	type: '用户级别',
	log: '系统日志',
	config: '系统配置',
	paramKey: '参数名',
	paramValue: '参数值',
	remark: '备注',
	serialNo: '设备序列号',
	serial_no: '设备序列号',
	status:'状态',
	expiration_time:'设备到期时间',
	goods_sku:"SKU",
	id:'装箱ID',
	upload_state:'状态',
	marca_comercial:'Brand',
	retryUpload:'重新上传',
};